import { Directive, Input } from '@angular/core';
import { Behavior } from './types-and-interfaces';

@Directive({
  selector: 'crm-dropdown-content, [crmDropdownContent]',

})
export class DropdownContentDirective {
  behavior?: Behavior;

  @Input({ required: true }) set onState(value: Behavior) {
    this.behavior = value;
  }
}
